import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { closeModal } from '../../actions/close-modal';
import Modal from '../../components/modal';
import DemoConfirmation from '../../components/demo-confirmation';
import { isTemplate } from '../../services/is-template';
import withTranslate from '../../hoc/with-translate';

export const DemoModal = ({ viewMode, closeModal, t }) => {
  let type = viewMode;
  if (viewMode === 'site' && isTemplate()) {
    type = 'template';
  }

  return (
    <Modal onClose={closeModal}>
      <DemoConfirmation
        title={t('demo-modal.demo-mode')}
        message={t(`demo-modal.message-${type}`)}
        confirmButton={t(viewMode === 'preview' ? 'demo-modal.activate-forum' : 'demo-modal.confirm')}
        onConfirm={() => {
          closeModal(viewMode === 'preview');
        }}
        onCancel={closeModal}
      />
    </Modal>
  );
};

DemoModal.propTypes = {
  viewMode: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      closeModal,
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(withTranslate(DemoModal));



// WEBPACK FOOTER //
// ./app/containers/demo-modal/demo-modal.js